module.exports = __webpack_public_path__ + "static/media/PoemProductImg.5e248f8e.jpeg";